"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menu = void 0;
var tslib_1 = require("tslib");
var classnames_1 = (0, tslib_1.__importDefault)(require("classnames"));
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
var theme_1 = require("../../theme");
var colors_1 = require("../../theme/colors");
var padding_1 = require("../padding");
var stack_1 = require("../stack");
var text_1 = require("../text");
function Menu(props) {
    var items = props.items, onToggle = props.onToggle;
    function renderMenuItem(item) {
        var label = item.label, isSelected = item.isSelected, href = item.href, target = item.target, isDisabled = item.isDisabled, onClick = item.onClick;
        return (react_1.default.createElement(StyledMenuItem, { className: (0, classnames_1.default)({ isDisabled: isDisabled, isSelected: isSelected }), key: label, onClick: function (event) {
                if (!isDisabled && onClick) {
                    onClick(!isSelected);
                }
                if (onToggle) {
                    onToggle(false);
                }
                event.stopPropagation();
            }, role: "menuitem", href: !isDisabled && href, target: target },
            react_1.default.createElement(padding_1.Padding, { x: 24 }, label)));
    }
    function renderDividerItem() {
        return react_1.default.createElement(StyledDivider, { key: "divider" });
    }
    function renderGroupItem(item) {
        var _a = item.group, label = _a.label, childItems = _a.items;
        return (react_1.default.createElement("div", { key: "".concat(label, " items") },
            react_1.default.createElement(padding_1.Padding, { x: 16, bottom: 8 },
                react_1.default.createElement(text_1.Text, { color: "light" }, label)),
            childItems.map(renderMenuItem)));
    }
    function isGroupItem(object) {
        return 'group' in object;
    }
    function isDividerItem(object) {
        return 'divider' in object && object.divider === true;
    }
    var menuItems = items.map(function (item) {
        if (isGroupItem(item)) {
            return renderGroupItem(item);
        }
        if (isDividerItem(item)) {
            return renderDividerItem();
        }
        return renderMenuItem(item);
    });
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(stack_1.Stack, { gap: 0, direction: "vertical" }, menuItems)));
}
exports.Menu = Menu;
var StyledMenuItem = styled_components_1.default.a(templateObject_1 || (templateObject_1 = (0, tslib_1.__makeTemplateObject)(["\n  color: ", ";\n  cursor: pointer;\n  &.isSelected {\n    color: ", ";\n  }\n  &.isDisabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n  display: block;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 40px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  &:not(.isDisabled):hover {\n    color: ", ";\n    background: ", ";\n    text-decoration: none;\n  }\n"], ["\n  color: ", ";\n  cursor: pointer;\n  &.isSelected {\n    color: ", ";\n  }\n  &.isDisabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n  display: block;\n  font-family: ", ";\n  font-size: 14px;\n  line-height: 40px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  &:not(.isDisabled):hover {\n    color: ", ";\n    background: ", ";\n    text-decoration: none;\n  }\n"])), colors_1.colors.steel[400], colors_1.colors.brand[400], colors_1.colors.steel[200], theme_1.fontFamilies.body, colors_1.colors.brand[400], colors_1.colors.brand[100]);
var StyledDivider = styled_components_1.default.div(templateObject_2 || (templateObject_2 = (0, tslib_1.__makeTemplateObject)(["\n  background-color: ", ";\n  height: 1px;\n  width: 100%;\n"], ["\n  background-color: ", ";\n  height: 1px;\n  width: 100%;\n"])), colors_1.colors.steel[200]);
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map